import React, { useState, useEffect } from 'react';
import './JobsPage.css';
import PageSerch from '../SerchDocters/Components/PageSerch';
import DynamicBreadcrumbs from '../../../Uitiles/DynamicBreadcrumbs';
import PageSidebar from '../../../Uitiles/PageSidebar';

const tabs = [
	{ key: 'doctors', label: 'Doctor Jobs' },
	{ key: 'nurses', label: 'Nurse Jobs' },
	{ key: 'technicians', label: 'Medical Technicians  Jobs' },
	{ key: 'front-desk-staff', label: 'Front Desk Staff' },
];

const medicalJobs = [
	{
		id: 'cardiologist-bangalore',
		company: 'Apollo Hospitals',
		// logo: '/assets/images/hospitals/apollo.png',
		jobTitle: 'Senior Cardiologist',
		location: 'Bangalore, Karnataka',
		package: '₹18-25 LPA',
		experience: '5-8 years',
		skills: ['MD Medicine', 'DM Cardiology', 'Cardiac procedures', 'Patient care', 'Team leadership'],
		jobType: 'Full-time',
		department: 'Cardiology',
		description: 'Leading cardiac procedures and patient care in a premier medical facility.',
		postedDate: '2 days ago',
		isUrgent: true,
	},
	{
		id: 'nurse-orthopedic-mumbai',
		company: 'Fortis Healthcare',
		// logo: '/assets/images/hospitals/fortis.png',
		jobTitle: 'Orthopedic Nurse',
		location: 'Mumbai, Maharashtra',
		package: '₹4-6 LPA',
		experience: '2-4 years',
		skills: ['Orthopedic nursing', 'Patient mobility', 'Post-surgical care', 'Rehabilitation', 'Medical records'],
		jobType: 'Full-time',
		department: 'Orthopedics',
		description: 'Specialized nursing care for orthopedic patients including post-surgical rehabilitation.',
		postedDate: '1 day ago',
		isUrgent: false,
	},
	{
		id: 'lab-technician-delhi',
		company: 'Medanta Hospital',
		// logo: '/assets/images/hospitals/medanta.png',
		jobTitle: 'Senior Lab Technician',
		location: 'Delhi, NCR',
		package: '₹5-8 LPA',
		experience: '3-5 years',
		skills: ['Pathology testing', 'Lab equipment', 'Quality control', 'Report generation', 'Bio specimen handling'],
		jobType: 'Full-time',
		department: 'Pathology',
		description: 'Conducting comprehensive laboratory tests and maintaining quality standards.',
		postedDate: '3 days ago',
		isUrgent: false,
	},
	{
		id: 'receptionist-chennai',
		company: 'Manipal Hospitals',
		// logo: '/assets/images/hospitals/manipal.png',
		jobTitle: 'Front Desk Executive',
		location: 'Chennai, Tamil Nadu',
		package: '₹2.5-4 LPA',
		experience: '1-3 years',
		skills: ['Patient registration', 'Appointment scheduling', 'Insurance verification', 'Multi-tasking', 'Communication'],
		jobType: 'Full-time',
		department: 'Administration',
		description: 'Managing front desk operations and ensuring smooth patient flow.',
		postedDate: '4 days ago',
		isUrgent: false,
	},
	{
		id: 'physiotherapist-pune',
		company: 'Kokilaben Hospital',
		// logo: '/assets/images/hospitals/kokilaben.png',
		jobTitle: 'Senior Physiotherapist',
		location: 'Pune, Maharashtra',
		package: '₹6-9 LPA',
		experience: '3-6 years',
		skills: ['Physical therapy', 'Rehabilitation', 'Manualtherapy', 'Sports medicine', 'Patient assessment'],
		jobType: 'Full-time',
		department: 'Physiotherapy',
		description: 'Providing advanced physiotherapy treatments and rehabilitation services.',
		postedDate: '5 days ago',
		isUrgent: true,
	},
	{
		id: 'radiologist-hyderabad',
		company: 'KIMS Hospital',
		// logo: '/assets/images/hospitals/kims.png',
		jobTitle: 'Consultant Radiologist',
		location: 'Hyderabad, Telangana',
		package: '₹20-30 LPA',
		experience: '6-10 years',
		skills: ['Medical imaging', 'CT scans', 'MRI interpretation', 'Ultrasound', 'Medical reporting'],
		jobType: 'Full-time',
		department: 'Radiology',
		description: 'Expert interpretation of medical imaging studies and diagnostic reports.',
		postedDate: '6 days ago',
		isUrgent: false,
	},
];

const nurseJobs = [
	{
		id: 'icu-nurse-gurgaon',
		company: 'Max Healthcare',
		// logo: '/assets/images/hospitals/max.png',
		jobTitle: 'ICU Nurse',
		location: 'Gurgaon, Haryana',
		package: '₹5-7 LPA',
		experience: '3-5 years',
		skills: ['ICU patient care', 'Ventilator management', 'Emergency protocols', 'Medication administration', 'Critical monitoring'],
		jobType: 'Full-time',
		department: 'Intensive Care',
		description: 'Providing critical care nursing in intensive care unit.',
		postedDate: '1 day ago',
		isUrgent: true,
	},
];

const technicianJobs = [
	{
		id: 'mri-tech-kolkata',
		company: 'Peerless Hospital',
		// logo: '/assets/images/hospitals/peerless.png',
		jobTitle: 'MRI Technician',
		location: 'Kolkata, West Bengal',
		package: '₹6-10 LPA',
		experience: '2-4 years',
		skills: ['MRI operation', 'Patient positioning', 'Safety protocols', 'Image quality', 'Equipment maintenance'],
		jobType: 'Full-time',
		department: 'Radiology',
		description: 'Operating MRI equipment and ensuring high-quality diagnostic images.',
		postedDate: '2 days ago',
		isUrgent: false,
	},
];

export default function JobsPage() {
	const [activeTab, setActiveTab] = useState('doctors');
	const [showModal, setShowModal] = useState(false);
	const [selectedJob, setSelectedJob] = useState(null);

	useEffect(() => {
		if (showModal) {
			document.body.classList.add('modal-open');
		} else {
			document.body.classList.remove('modal-open');
		}
		return () => {
			document.body.classList.remove('modal-open');
		};
	}, [showModal]);

	const getJobsForTab = (tab) => {
		switch (tab) {
			case 'doctors':
				return medicalJobs;
			case 'nurses':
				return nurseJobs;
			case 'technicians':
				return technicianJobs;
			case 'front-desk-staff':
				return medicalJobs.filter(job => job.department === 'Administration');
			default:
				return medicalJobs;
		}
	};

	const handleApplyJob = (job) => {
		setSelectedJob(job);
		setShowModal(true);
	};

	const renderJobsList = (jobs) => {
		if (jobs.length === 0) {
			return (
				<div className="no-jobs">
					<h3>No jobs found</h3>
					<p>Please check back later for new opportunities.</p>
				</div>
			);
		}

		return (
			<div className="jobs-list">
				{jobs.map(job => (
					<article key={job.id} className="job-card" role="article" aria-label={`Job opening: ${job.jobTitle} at ${job.company}`}>
						<div className="card-body">
							<div className="row align-items-center g-3">
								<div className="col-md-4">
									<header className="company-head">
										{job.logo ? (
											<img className="company-logo" src={job.logo} alt={`${job.company} logo`} onError={(e) => { e.currentTarget.style.display = 'none'; }} />
										) : (
											<div className="company-logo-placeholder">{job.company.charAt(0)}</div>
										)}
										<h3 className="company-name">{job.company}</h3>
									</header>
									<div className="job-title" role="text" aria-label={`Job Title: ${job.jobTitle}`}>{job.jobTitle}</div>
									<div className="job-department">{job.department}</div>
								</div>
								<div className="col-md-6">
									<div className="job-metrics" role="group" aria-label="Job details">
										<div className="job-metric job-meta">
											<div className="label">Package</div>
											<div className="value" aria-label={`Salary: ${job.package}`}>{job.package}</div>
										</div>
										<div className="job-metric job-meta">
											<div className="label">Experience</div>
											<div className="value" aria-label={`Experience required: ${job.experience}`}>{job.experience}</div>
										</div>
										<div className="job-metric job-meta">
											<div className="label">Location</div>
											<div className="value" aria-label={`Location: ${job.location}`}>{job.location}</div>
										</div>
										<div className="job-metric job-meta">
											<div className="label">Type</div>
											<div className="value" aria-label={`Job type: ${job.jobType}`}>{job.jobType}</div>
										</div>
									</div>
								</div>
								<div className="col-md-2 text-md-end">
									<button 
										className={`job-cta ${job.isUrgent ? 'urgent' : ''}`} 
										onClick={() => handleApplyJob(job)} 
										aria-label={`Apply for ${job.jobTitle}`}
									>
										{job.isUrgent ? 'Apply Urgently' : 'Apply Now'}
									</button>
									<div className="job-posted mt-1" role="text" aria-label={`Posted: ${job.postedDate}`}>{job.postedDate}</div>
								</div>
							</div>

							<div className="row mt-3">
								<div className="col-12">
									<div className="job-description mb-3">
										<p>{job.description}</p>
									</div>
								</div>
								<div className="col-12">
									<div className="job-skills mb-3" role="list" aria-label="Required skills">
										<div className="skills-label">Skills Required:</div>
										<div className="skills-container">
											{job.skills.map((skill, index) => (
												<div key={index} className="skill-pill" role="listitem">
													<span className="skill-icon" aria-hidden="true">🏥</span>
													<span>{skill}</span>
												</div>
											))}
										</div>
									</div>
								</div>
								<div className="col-12">
									<div className="job-footer-badges" role="list" aria-label="Job features">
										<div className="footer-badge blue" role="listitem">
											<span aria-hidden="true">🔵</span>
											<span>{job.jobType}</span>
										</div>
										<div className="footer-badge green" role="listitem">
											<span aria-hidden="true">✅</span>
											<span>Immediate joining available</span>
										</div>
										{job.isUrgent && (
											<div className="footer-badge urgent" role="listitem">
												<span aria-hidden="true">⚡</span>
												<span>Urgent hiring</span>
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
					</article>
				))}
			</div>
		);
	};

	return (
		<>
			<PageSerch />
			<DynamicBreadcrumbs />

			<div className="container py-4 jobs-wrap">
				<div className="">
					<h2 className="mb-3 text-start" style={{ textAlign: 'start' }}>Medical Jobs in India 2025</h2>
					<div className="d-flex justify-content-start gap-2 mb-4" style={{ gap: 10 }}>
						{tabs.map(t => (
							<button
								key={t.key}
								onClick={() => setActiveTab(t.key)}
								className={`btn ${activeTab === t.key ? 'btn-primary' : 'btn-outline-secondary'} job-tabs`}
							>
								{t.label}
							</button>
						))}
					</div>

					<div id="dc-twocolumns" className="dc-twocolumns dc-haslayout d-flex dc-enabled">
						<div className="jobs-list-container col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-9 order-first">
							{renderJobsList(getJobsForTab(activeTab))}
						</div>

						<div className="col-12 col-md-5 col-lg-4 col-xl-3 order-last">
							<PageSidebar />
						</div>
					</div>

					{showModal && selectedJob && (
						<div className="modal-overlay" onClick={() => { setShowModal(false); }}>
							<div className="jobs-modal" onClick={(e) => e.stopPropagation()}>
								<div className="modal-header">
									<h3>Apply for {selectedJob.jobTitle}</h3>
									<button className="close" onClick={() => setShowModal(false)}>×</button>
								</div>
								<div className="modal-body">
									<div className="job-details">
										<div className="company-info">
											{selectedJob.logo && (
												<img className="company-logo-modal" src={selectedJob.logo} alt={`${selectedJob.company} logo`} />
											)}
											<h4>{selectedJob.company}</h4>
										</div>
										<p><strong>Position:</strong> {selectedJob.jobTitle}</p>
										<p><strong>Location:</strong> {selectedJob.location}</p>
										<p><strong>Package:</strong> {selectedJob.package}</p>
										<p><strong>Experience:</strong> {selectedJob.experience}</p>
										<p><strong>Department:</strong> {selectedJob.department}</p>
									</div>

									<form className="application-form">
										<div className="form-group">
											<label htmlFor="applicantName">Full Name *</label>
											<input type="text" id="applicantName" name="applicantName" required />
										</div>
										<div className="form-group">
											<label htmlFor="applicantEmail">Email *</label>
											<input type="email" id="applicantEmail" name="applicantEmail" required />
										</div>
										<div className="form-group">
											<label htmlFor="applicantPhone">Phone Number *</label>
											<input type="tel" id="applicantPhone" name="applicantPhone" required />
										</div>
										<div className="form-group">
											<label htmlFor="applicantExperience">Years of Experience</label>
											<input type="number" id="applicantExperience" name="applicantExperience" min="0" />
										</div>
										<div className="form-group">
											<label htmlFor="applicantResume">Upload Resume *</label>
											<input type="file" id="applicantResume" name="applicantResume" accept=".pdf,.doc,.docx" required />
										</div>
										<div className="form-group">
											<label htmlFor="coverLetter">Cover Letter</label>
											<textarea id="coverLetter" name="coverLetter" rows="4" placeholder="Tell us why you're interested in this position..."></textarea>
										</div>
										<div className="form-group checkbox-group">
											<label>
												<input type="checkbox" name="termsAccepted" required />
												I agree to the terms and conditions and privacy policy
											</label>
										</div>
										<button type="submit" className="submit-application-btn">
											Submit Application
										</button>
									</form>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		</>
	);
}
